import React from 'react';
import { Box } from '@mui/material';
import General from './General';
import PropTypes from 'prop-types';

const BasicSettings = ({ defaultSettings, fetchData }) => {
  return (
    <Box sx={{ mt: 4 }}>
      {defaultSettings?.basic && (
        <General
          settings={defaultSettings.basic}
          fetchData={fetchData}
        />
      )}
    </Box>
  );
};

BasicSettings.propTypes = {
  defaultSettings: PropTypes.object,
  fetchData: PropTypes.func,
};
export default BasicSettings;
